import PageProgress from './PageProgress';

export default PageProgress;
